import React, { useContext } from 'react'
import { Box } from '../../Components/Layout'
import { MatchupContext } from '../../Context'
import { SectionHeading } from '../../Components/Headers'
import { RosterTabs } from './components/rosters/rostersTabs'

export const Rosters: React.FC<React.PropsWithChildren<unknown>> = () => {
  const {
    teams: [awayTeam, homeTeam],
  } = useContext(MatchupContext)!
  return (
    <div>
      {awayTeam && homeTeam && (
        <Box noMargin boxColor="grey">
          <SectionHeading lowMargin headingColor="light">
            <strong>Rosters</strong>
          </SectionHeading>
          <RosterTabs
            awayTeam={awayTeam.data.fullName}
            homeTeam={homeTeam.data.fullName}
          />
        </Box>
      )}
    </div>
  )
}
